var map = {
	"./download-on-the-app-store-da.svg": "d7a7",
	"./download-on-the-app-store-de.svg": "4f74",
	"./download-on-the-app-store-en.svg": "1537",
	"./download-on-the-app-store-es.svg": "5585",
	"./download-on-the-app-store-fr.svg": "438e",
	"./download-on-the-app-store-sv.svg": "227e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ba";